import {useTranslation} from 'react-i18next';
import * as css from './TicketCardCarousel.css';

interface CarouselDotsProps {
    count: number;
    activeIndex: number;
    onSelect: (index: number) => void;
}

function CarouselDots({count, activeIndex, onSelect}: CarouselDotsProps) {
    const {t} = useTranslation('eTicket');
    return (
        <css.dots>
            {Array.from({length: count}, (_, index) => (
                <css.dot
                    key={index}
                    className={index === activeIndex ? 'is-active' : ''}
                    data-cy={`entrance-ticket-dot-${index}`}
                    aria-label={t('cardAriaLabel', {number: index + 1})}
                    onClick={() => onSelect(index)}
                />
            ))}
        </css.dots>
    );
}

export default CarouselDots;
